// material-ui
import { TypographyVariantsOptions } from '@mui/material/styles';

// types
import { FontFamily } from 'types/config';

export default function Typography(fontFamily: FontFamily): TypographyVariantsOptions {
  return {
    fontFamily,
    h6: {
      fontFamily: `'Poppins', sans-serif`,
      fontWeight: 600,
      fontSize: '0.75rem'
    },
    h5: {
      fontFamily: `'Poppins', sans-serif`,
      fontSize: '0.875rem',
      fontWeight: 600
    },
    h4: {
      fontFamily: `'Montserrat', sans-serif`,
      fontSize: '1rem',
      fontWeight: 600
    },
    h3: {
      fontFamily: `'Montserrat', sans-serif`,
      fontSize: '1.25rem',
      fontWeight: 600
    },
    h2: {
      fontFamily: `'Poppins', sans-serif`,
      fontSize: '1.5rem',
      fontWeight: 600
    },
    h1: {
      fontFamily: `'Montserrat', sans-serif`,
      fontSize: '2.125rem',
      fontWeight: 600
    },
    subtitle1: {
      fontSize: '0.875rem',
      fontWeight: 500
    },
    subtitle2: {
      fontSize: '0.75rem',
      fontWeight: 400
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400
    },
    body1: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.334em'
    },
    body2: {
      letterSpacing: '0em',
      fontWeight: 400,
      lineHeight: '1.5em'
    },
    button: {
      fontFamily: `'Montserrat', sans-serif`,
      fontWeight: 600,
      textTransform: 'none'
    },
    commonAvatar: {
      cursor: 'pointer',
      borderRadius: '8px'
    },
    smallAvatar: {
      width: '22px',
      height: '22px',
      fontSize: '1rem'
    },
    mediumAvatar: {
      width: '34px',
      height: '34px',
      fontSize: '1.2rem'
    },
    largeAvatar: {
      width: '44px',
      height: '44px',
      fontSize: '1.5rem'
    }
  };
}
